import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.css';

interface FooterProps {
  darkMode: boolean;
}

const Footer: React.FC<FooterProps> = ({ darkMode }) => {
  const navigate = useNavigate();

  return (
    <footer className={`app-footer ${darkMode ? 'dark' : ''}`}>
      <div className="footer-content">
        <div className="footer-section company-info">
          <h3>Global Referral Program by Jobometry</h3>
          <p>Refer great people. Earn rewards.</p>
          <address>
            Jobometry Ltd<br />
            71-75 Shelton St<br />
            London WC2H 9JQ, UK
          </address>
        </div>

        <div className="footer-section links">
          <h4>Platform</h4>
          <ul>
            <li><button onClick={() => navigate('/vacancies')}>Browse Vacancies</button></li>
            <li><button onClick={() => navigate('/post-vacancy')}>Post a Vacancy</button></li>
            <li><button onClick={() => navigate('/my-referrals')}>My Referrals</button></li>
          </ul>
        </div>

        <div className="footer-section links">
          <h4>Company</h4>
          <ul>
            <li><button onClick={() => navigate('/')}>About</button></li>
            <li><button onClick={() => { const el = document.querySelector('.faq-section'); el?.scrollIntoView({ behavior: 'smooth' }); }}>FAQ</button></li>
            <li><button onClick={() => navigate('/vacancies')}>Pricing</button></li>
          </ul>
        </div>

        <div className="footer-section links">
          <h4>Support</h4>
          <ul>
            <li><a href="mailto:support@jobometry.io">Help Center</a></li>
            <li><a href="mailto:sales@jobometry.io">Contact Us</a></li>
          </ul>
        </div>

        <div className="footer-section legal">
          <h4>Legal</h4>
          <ul>
            <li><a href="/terms.html">Terms of Service</a></li>
            <li><a href="/privacy.html">Privacy Policy</a></li>
            <li><a href="/cookies">Cookie Policy</a></li>
          </ul>
        </div>

        <div className="footer-section social">
          <h4>Connect</h4>
          <ul>
            <li><a href="https://linkedin.com/company/jobometry" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
            <li><a href="https://twitter.com/jobometry" target="_blank" rel="noopener noreferrer">Twitter</a></li>
            <li><a href="mailto:sales@jobometry.io">Email Us</a></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Jobometry Ltd. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
